import { Loader2 } from "lucide-react";
import { useFeatures } from "@/context/FeaturesContext";
import { formatTenantFeature, isTenantFeatureEnabled } from "@/lib/tenantBillingAccess";
import UpgradeFeatureNotice from "@/components/billing/UpgradeFeatureNotice";

export default function FeatureAccessGate({ featureKey, children }) {
  const { access, loading } = useFeatures();

  if (loading) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-500">
        <Loader2 className="mr-2 inline h-4 w-4 animate-spin" />
        Checking feature access...
      </div>
    );
  }

  if (isTenantFeatureEnabled(access, featureKey)) return children;

  return <UpgradeFeatureNotice featureLabel={formatTenantFeature(featureKey)} packageSegment={access?.package_segment} />;
}
